// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__9izmY","logo":"MainNavigation_logo__qWN6F","active":"MainNavigation_active__309IC","badge":"MainNavigation_badge__zkqp-"};